import {
    api_admin_companies_get,
    api_admin_companies_search_list,
    api_admin_users_patch,
    api_admin_users_post,
    Company,
    Province,
    StaffRole,
    User,
} from 'abi'
import {
    addAlert,
    HoverInp,
    LoadingDots,
    PassCheck,
    setPopup,
} from 'components'
import {
    CalendarIcon,
    CheckFillIcon,
    CloseIcon,
    CorpsIcon,
    DeleteIcon,
    MapIcon,
    PassIcon,
    UserIcon,
    WarningIcon,
} from 'icons'
import {
    Component,
    createEffect,
    createMemo,
    For,
    on,
    onCleanup,
    Show,
} from 'solid-js'
import { createStore, produce, unwrap } from 'solid-js/store'

import './style/add.scss'

import Dropdown from 'components/dropdown'
import { debounce, deepcopy, objentries } from 'utils/tools'
import { USERSTATE } from '.'
import { PROVINCE_FA } from '../profile'

interface AddUserCmpProps {
    add: USERSTATE['add']

    onClose(): void

    onAdd(c: User): void
    onEdit(c: User): void
}
export const AddUserCmp: Component<AddUserCmpProps> = P => {
    type STATE = {
        loading: boolean
        status: null | 'green' | 'red'

        name: string
        username: string
        pass: string

        corp: {
            id: Company['id'] | null
            name: Company['name']
            query: string
            loading: boolean
        }

        staff_role: StaffRole

        province: Province

        badPass: boolean

        anim: boolean
    }
    const STATE_DEFAULT: STATE = {
        loading: false,
        status: null,

        name: '',
        pass: '',
        username: '',

        staff_role: 'agent',

        corp: {
            id: null,
            query: '',
            name: '',
            loading: false,
        },

        province: 'none',

        badPass: true,

        anim: false,
    }
    const [state, setState] = createStore<STATE>(deepcopy(STATE_DEFAULT))

    createEffect(
        on(
            () => P.add.show,
            () => {
                let p = P.add
                if (!p.show) closed()

                let u = unwrap(p.user)

                let corp = {
                    id: u?.staff_at || null,
                    query: '',
                    name: '',
                    loading: false,
                }

                setState({
                    ...deepcopy(STATE_DEFAULT),
                    name: u?.name || '',
                    username: u?.username || '',
                    pass: '',
                    badPass: p.type === 'add' ? true : false,
                    staff_role: u?.staff_role ?? STATE_DEFAULT['staff_role'],
                    province: u?.province || 'none',
                    // perms: old_perms(),
                    corp,
                })

                if (u?.staff_at) {
                    getCorp(u!.staff_at)
                }
            }
        )
    )

    const getCorp = async (id: number) => {
        setState('corp', 'loading', true)
        let res = await api_admin_companies_get({ id })
        setState('corp', 'loading', false)

        if (!res.ok())
            return setState('corp', {
                id: null,
            })

        let c = res.body
        setState('corp', {
            id: c.id,
            name: c.name,
            query: '',
        })
    }

    const closed = () => {
        setState(deepcopy(STATE_DEFAULT))
    }

    const changed = createMemo(() => {
        let u = P.add.user
        let s = state

        if (P.add.type == 'add') {
            if (s.name.length !== 0 || s.username.length !== 0) return true
            return false
        }

        let c_role = u?.staff_role != s.staff_role

        let c_name = !!u?.name ? u?.name !== s.name : s.name.length !== 0
        let c_username = u?.username !== s.username
        let c_corp = u?.staff_at !== s.corp.id
        let c_pass = !s.badPass && s.pass.length > 0
        let c_province = s.province !== (u?.province || 'none')

        return c_name || c_username || c_corp || c_pass || c_role || c_province
    })

    const isDisabled = createMemo(() => {
        return (
            (state.badPass && P.add.type == 'add') ||
            !state.name ||
            !state.username
        )
    })

    const checkForm = async () => {
        if (state.loading || state.status) return

        const d = deepcopy(state)

        if (P.add.type === 'add' && (d.pass.length === 0 || d.badPass)) {
            // 1) ADD: password is required and must be valid
            return addAlert({
                type: 'error',
                subject: 'مشکل رمز',
                timeout: 3,
                content: 'رمز عبور را به درستی وارد کنید.',
            })
        }

        // 2) EDIT: password optional, but if user typed one it must be valid
        if (P.add.type === 'edit' && d.pass.length !== 0 && d.badPass) {
            return addAlert({
                type: 'error',
                subject: 'مشکل رمز',
                timeout: 3,
                content: 'رمز عبور جدید را به درستی وارد کنید.',
            })
        }

        if (!d.username) {
            return addAlert({
                type: 'error',
                subject: 'مشکل نام کاربری',
                timeout: 3,
                content: 'نام کاربری را به درستی وارد کنید.',
            })
        }

        if (!d.name) {
            return addAlert({
                type: 'error',
                subject: 'مشکل نام ',
                timeout: 3,
                content: 'نام نماینده را به درستی وارد کنید.',
            })
        }

        setState({ loading: true })

        let res

        let id = P.add.user?.id || -1

        if (P.add.type == 'add') {
            let createRes = await api_admin_users_post(
                { password: d.pass, username: d.username },
                { show_alert: true }
            )
            if (!createRes.ok()) {
                setState({ loading: false })

                return setState({ status: 'red' })
            }
            id = createRes.body.id
        }

        res = await api_admin_users_patch(
            { id },
            {
                name: d.name,
                banned: false,
                password: d.pass || null,
                username: d.username,
                staff_at: d.corp.id,
                staff_role: d.staff_role,
                province: d.province,
            },
            { show_alert: true }
        )

        setState({ loading: false })

        if (!res.ok()) return setState({ status: 'red' })

        setState({ status: 'green' })

        if (P.add.type == 'edit') {
            P.onEdit({
                ...res.body,
                id: P.add.user!.id,
            })
        } else {
            pop_conffeties()
            P.onAdd({ ...res.body })
        }
    }

    const pop_conffeties = () => {
        // @ts-ignore
        if (typeof window.confetti !== 'function') return

        const count = 200,
            defaults = {
                origin: { y: 0.7 },
            }

        function fire(particleRatio: number, opts: any) {
            // @ts-ignore
            window.confetti(
                Object.assign({}, defaults, opts, {
                    particleCount: Math.floor(count * particleRatio),
                })
            )
        }

        fire(0.25, {
            spread: 26,
            startVelocity: 55,
        })

        fire(0.2, {
            spread: 60,
        })

        fire(0.35, {
            spread: 100,
            decay: 0.91,
            scalar: 0.8,
        })

        fire(0.1, {
            spread: 120,
            startVelocity: 25,
            decay: 0.92,
            scalar: 1.2,
        })

        fire(0.1, {
            spread: 120,
            startVelocity: 45,
        })
    }

    const OnClose = () => {
        if (state.loading) return

        if (state.status == 'red')
            return setState({ loading: false, status: null })

        if (changed() && !state.status) {
            return setPopup({
                show: true,
                content: 'بعد از خروج موارد تغییر یافته ذخیره نمیشوند!',
                Icon: WarningIcon,
                title: 'ذخیره نکردید!',
                type: 'warning',
                onSubmit() {
                    P.onClose()
                },
            })
        }

        P.onClose()
    }

    const CorpPick: Component = () => {
        let resultsRef: HTMLElement

        type DATA = {
            loading: boolean
            error: boolean

            corps: Company[]
        }
        const [data, setData] = createStore<DATA>({
            loading: false,
            error: false,

            corps: [],
        })

        createEffect(
            on(
                () => state.corp.query,
                s => {
                    if (!resultsRef) return

                    setData({ loading: true, error: false })

                    if (s.length == 0) {
                        if (state.corp.name) {
                            resultsRef.style.opacity = '0'
                            resultsRef.style.maxHeight = '0px'
                        } else {
                            resultsRef.style.opacity = '1'
                            resultsRef.style.maxHeight = '150px'
                        }

                        return
                    }

                    searchCorps(s)
                },
                {
                    defer: true,
                }
            )
        )
        onCleanup(() => {
            setData({
                loading: false,
                error: false,

                corps: [],
            })
        })

        const setActive = () => {
            let height = resultsRef.scrollHeight

            resultsRef.style.maxHeight = `${height}px`
            resultsRef.style.opacity = '1'
        }

        const searchCorps = debounce(async (query: string) => {
            let res = await api_admin_companies_search_list({
                name: `%${query}%`,
            })

            setData({ loading: false })

            if (!res.ok() || res.body.length == 0)
                return setData({ error: true })

            if (state.corp.query !== query) return

            setData({
                corps: res.body.slice(0, 10),
            })
            setActive()
        }, 200)

        const fireCorp = () => {
            setState(
                produce(s => {
                    s.corp = {
                        id: null,
                        name: '',
                        query: '',
                        loading: false,
                    }
                    s.staff_role = 'agent'
                })
            )
        }

        const Loading = () => {
            return (
                <div class='loading-result title'>
                    <LoadingDots />
                    درحال گرفتن شرکت ها
                </div>
            )
        }
        const Error = () => {
            return (
                <div class='error-result title'>
                    <CloseIcon />
                    شرکتی یافت نشد!
                </div>
            )
        }

        interface CorpProps extends Company {
            onClick(): void
        }
        const Corp: Component<CorpProps> = C => {
            return (
                <div role='button' class='corp-res' onclick={C.onClick}>
                    <div class='head title_small'>{C.name}</div>
                    <div class='bottom description'>
                        <div class='data'>{C.agent_count} نماینده</div>•
                        <div class='data'>
                            <CalendarIcon />
                            {new Date(C.created_at * 1e3).toLocaleDateString(
                                'fa-IR'
                            )}
                        </div>
                    </div>
                </div>
            )
        }

        const SelectPerm: Component = () => {
            const isM = createMemo(() => state.staff_role == 'manager')

            const setP = (staff_role: StaffRole) => {
                setState({ staff_role })
            }

            return (
                <div class='select-perm'>
                    <div class='holder title_smaller'>
                        <span>نقش در شرکت</span>
                    </div>
                    <div
                        class='picker title_smaller'
                        classList={{ active: isM() }}
                    >
                        <div
                            role='button'
                            class='pick'
                            onclick={() => setP('agent')}
                        >
                            نماینده
                        </div>
                        <div
                            role='button'
                            class='pick'
                            onclick={() => setP('manager')}
                        >
                            مدیرعامل
                        </div>
                    </div>
                </div>
            )
        }

        const active = createMemo(
            () => state.corp.name.length !== 0 || state.corp.query.length !== 0
        )
        const value = createMemo(() =>
            state.corp.name ? state.corp.name : state.corp.query
        )

        return (
            <div class='inp-rows'>
                <div class='hover-inp-wrapper'>
                    <HoverInp
                        holder={'شرکت (اختیاری)'}
                        inpType='text'
                        acitve={active()}
                        value={value()}
                        onInp={e => setState(produce(s => (s.corp.query = e)))}
                        Icon={<CorpsIcon />}
                        dir='rtl'
                    />
                    <Show when={P.add.user?.staff_at}>
                        <button
                            type='button'
                            class='del-corp icon'
                            onclick={fireCorp}
                        >
                            <div class='tooltip description'>حذف از شرکت</div>
                            <DeleteIcon />
                        </button>
                    </Show>
                </div>

                <Show when={state.corp.id}>
                    <SelectPerm />
                </Show>

                <div
                    class='result-wrapper'
                    classList={{ active: state.corp.query.length !== 0 }}
                    ref={e => (resultsRef = e)}
                >
                    <Show when={!data.loading} fallback={<Loading />}>
                        <Show when={!data.error} fallback={<Error />}>
                            <For each={data.corps}>
                                {c => (
                                    <Corp
                                        onClick={() =>
                                            setState('corp', {
                                                id: c.id,
                                                name: c.name,
                                                query: '',
                                            })
                                        }
                                        {...c}
                                    />
                                )}
                            </For>
                        </Show>
                    </Show>
                </div>
            </div>
        )
    }

    return (
        <div
            class='add-user-cmp'
            classList={{ show: P.add.show }}
            onclick={OnClose}
        >
            <div
                class='add-user-wrapper'
                onclick={e => {
                    e.stopPropagation()
                }}
            >
                <div
                    class='scaler'
                    onanimationend={() => setState({ anim: true })}
                ></div>

                <form
                    onsubmit={e => {
                        e.preventDefault()
                        checkForm()
                    }}
                    class='card'
                >
                    <button class='close icon' type='button' onclick={OnClose}>
                        <CloseIcon />
                    </button>
                    <div class='overflow-form'>
                        <div class='logo-wrapper'>
                            <img
                                class='logo'
                                decoding='async'
                                src='/public/imgs/logo.png'
                                alt=''
                            />
                            <div class='add-head'>
                                <p class='title_smaller sub'>اضافه کاربر در</p>
                                <p class='section_title main'>بیمه همراه</p>
                            </div>
                        </div>

                        <div class='inp-rows'>
                            <HoverInp
                                holder={'نام'}
                                inpType='text'
                                acitve={state.name.length !== 0}
                                value={state.name}
                                onInp={e =>
                                    setState(produce(s => (s.name = e)))
                                }
                                Icon={<UserIcon />}
                            />
                            <HoverInp
                                holder={'نام کاربری'}
                                inpType='username'
                                acitve={state.username.length !== 0}
                                value={state.username}
                                onInp={e =>
                                    setState(produce(s => (s.username = e)))
                                }
                                Icon={<UserIcon />}
                            />
                        </div>

                        <div class='inp-rows'>
                            <div class='province-pick'>
                                <div class='label title_smaller'>
                                    <MapIcon />
                                    استان کاربر
                                </div>
                                <Dropdown
                                    active={PROVINCE_FA[state.province]}
                                    items={objentries(PROVINCE_FA)
                                        .filter(([k]) => k !== state.province)
                                        .map(([k, v]) => ({
                                            name: v,
                                            value: k,
                                        }))}
                                    onchange={k =>
                                        setState('province', k as Province)
                                    }
                                    maxHeight={200}
                                />
                            </div>
                            <HoverInp
                                holder={'کلمه عبور'}
                                inpType='password'
                                acitve={state.pass.length !== 0}
                                value={state.pass}
                                onInp={e =>
                                    setState(produce(s => (s.pass = e)))
                                }
                                Icon={<PassIcon />}
                            />

                            <PassCheck
                                maxLength={12}
                                pass={state.pass}
                                show={state.pass.length !== 0}
                                onPassed={s => setState({ badPass: !s })}
                            />

                            <Show when={P.add.show}>
                                <CorpPick />
                            </Show>
                        </div>
                    </div>

                    <div class='cta-wrapper title_small'>
                        <button
                            class='cta'
                            type='submit'
                            classList={{ disable: isDisabled() || !changed() }}
                        >
                            ثبت
                        </button>
                    </div>

                    <div
                        class='loader title_hero'
                        classList={{ show: state.loading }}
                    >
                        <LoadingDots />
                        درحال ثبت کاربر
                    </div>
                    <div
                        class='status-wrapper'
                        classList={{
                            show: !!state.status,
                            [state.status || '']: true,
                        }}
                    >
                        <Show
                            when={state.status == 'green'}
                            fallback={<CloseIcon />}
                        >
                            <CheckFillIcon />
                        </Show>

                        <p class='title_hero'>
                            <Show
                                when={state.status == 'green'}
                                fallback={
                                    'خطا در ثبت کاربر، لطفا دوباره تلاش کنید.'
                                }
                            >
                                کاربر {state.name} با موفقیت ثبت شد!
                            </Show>
                        </p>
                    </div>
                </form>
            </div>
        </div>
    )
}
